import * as Zod from 'zod';

import { ICertificateWithScoringFragment } from 'graphql/types';
import { translate } from 'utils/i18n';
import { dateTimeValidator } from 'common/validators/dateTime';

export const getGenerateCertificateFormValidator = (
    certificate?: ICertificateWithScoringFragment | null,
    isExternalCertificate?: boolean
) =>
    Zod.object({
        certificate:
            isExternalCertificate || !!certificate
                ? Zod.custom<ICertificateWithScoringFragment>().nullable()
                : Zod.custom<ICertificateWithScoringFragment>()
                      .nullable()
                      .refine((val) => val !== null, {
                          message: translate('validate.required'),
                      }),
        issueDate: dateTimeValidator.nullable().refine((val) => val !== null, {
            message: translate('validate.required'),
        }),
        expiryDate: dateTimeValidator.nullable().optional(),
        title: !!certificate
            ? Zod.string().min(1, translate('validate.required'))
            : Zod.string(),
        fileId: Zod.string()
            .optional()
            .refine(
                (val) => !isExternalCertificate || (val && val.length > 0),
                {
                    message: translate('validate.required'),
                }
            ),
    }).refine(
        (data) => {
            if (!isExternalCertificate) return true;
            if (!data.issueDate || !data.expiryDate) return true;

            return data.issueDate < data.expiryDate;
        },
        {
            message: translate(
                'receivedCertificate.issueDateBeforeExpiryDateMessage'
            ),
            path: ['issueDate'],
        }
    );
